/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyCustomRoles: LazyComponent<any> = lazyForPaint<any>(
	() =>
		import(
			/* webpackChunkName: "async-jira-eoc-custom-roles", jiraSpaEntry: "async-jira-eoc-custom-roles" */ '@jira/eoc__custom-roles/src/index.tsx'
		),
);

const AsyncCustomRoles = (): React.JSX.Element => (
	<LazyPage Page={LazyCustomRoles} pageId="async-eoc-custom-roles" shouldShowSpinner={false} />
);

export default AsyncCustomRoles;
